import React from 'react';
import LibrarySubCategoryCreate from './views/Abuddy/Library/SubCategory/LibrarySubCategoryCreate';

const Users = React.lazy(() => import('./views/Users/Users'));
const UsersCreate = React.lazy(() => import('./views/Users/usersCreate'));
const UsersEdit = React.lazy(() => import('./views/Users/usersEdit'));
const AssesmentEdit = React.lazy(() => import('./views/Assesment/ListAssesment/AssesmentEdit'));
const SuggestionEdit = React.lazy(() => import('./views/Assesment/ListSuggestion/SuggestionEdit'));
const Products = React.lazy(() => import('./views/Products/products'));
const ProductDetail = React.lazy(() =>
  import('./views/Products/productDetail'),
);
const ProductCreate = React.lazy(() =>
  import('./views/Products/productCreate'),
);
const Customers = React.lazy(() => import('./views/Customer/customers'));
const CustomersDetail = React.lazy(() =>
  import('./views/Customer/customersDetail'),
);
const CustomersEdit = React.lazy(() =>
  import('./views/Customer/customersEdit'),
);
const CustomerStatus = React.lazy(() =>
  import('./views/Customer/customerStatus'),
);
const RichMenu = React.lazy(() =>
  import('./views/RichMenuManagement/RichMenu'),
);
const RichMenuCreate = React.lazy(() =>
  import('./views/RichMenuManagement/RichMenuCreate'),
);
const TmDashboard = React.lazy(() => import('./views/TmDashboard/TmDashboard'));
const TmLogsView = React.lazy(() => import('./views/TmDashboard/TmLogsView'));
const Messages = React.lazy(() => import('./views/Message/messages'));
const MessageCreate = React.lazy(() => import('./views/Message/messageCreate'));
const MessageEmail = React.lazy(() => import('./views/Message/messageEmail'));
const MessagesDetail = React.lazy(() =>
  import('./views/Message/messageDetail'),
);
const Profile = React.lazy(() => import('./views/Profile/Profile'));
const Dashboard = React.lazy(() => import('./views/Dashboard'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));
const UserActivities = React.lazy(() =>
  import('./views/UserActivities/userActivities'),
);
const UserActivitiesDetail = React.lazy(() =>
  import('./views/UserActivities/userActivitiesDetail'),
);
const questions = React.lazy(() => import('./views/Questions/questions'));
const questionCreate = React.lazy(() =>
  import('./views/Questions/questionCreate'),
);
const questionEditOrder = React.lazy(() =>
  import('./views/Questions/questionsEditOrder'),
);
const reports = React.lazy(() => import('./views/reports/report'));
const activityLog = React.lazy(() => import('./views/ActivityLog/ActivityLog'));
const abuddyIntroOA = React.lazy(() =>
  import('./views/Abuddy/IntroOA/IntroOA'),
);
const abuddyIntroOACreate = React.lazy(() =>
  import('./views/Abuddy/IntroOA/IntroOACreate'),
);
const abuddyIntroOADetail = React.lazy(() =>
  import('./views/Abuddy/IntroOA/IntroOADetail'),
);
const abuddyIntroOaOrder = React.lazy(() =>
  import('./views/Abuddy/IntroOA/IntroOaOrder'),
);
const abuddyIntroGroup = React.lazy(() =>
  import('./views/Abuddy/IntroGroup/IntroGroup'),
);
const abuddyIntroGroupCreate = React.lazy(() =>
  import('./views/Abuddy/IntroGroup/IntrGroupCreate'),
);
const abuddyIntroGroupDetail = React.lazy(() =>
  import('./views/Abuddy/IntroGroup/IntroGroupDetail'),
);
const abuddyIntroGroupOrder = React.lazy(() =>
  import('./views/Abuddy/IntroGroup/IntroGroupOrder'),
);
const abuddyCategory = React.lazy(() =>
  import('./views/Abuddy/Category/Category'),
);
const abuddyCategoryOrder = React.lazy(() =>
  import('./views/Abuddy/Category/CategoryOrder'),
);
const abuddyCategoryCreate = React.lazy(() =>
  import('./views/Abuddy/Category/CategoryCreate'),
);
const abuddyCategoryDetail = React.lazy(() =>
  import('./views/Abuddy/Category/CategoryDetail'),
);
const abuddySubCategory = React.lazy(() =>
  import('./views/Abuddy/SubCategory/SubCategory'),
);
const abuddyQuickReply = React.lazy(() =>
  import('./views/Abuddy/QuickReply/QuickReply'),
);
const abuddySubCategoryCreate = React.lazy(() =>
  import('./views/Abuddy/SubCategory/SubCategoryCreate'),
);
const abuddyQuickReplyCreate = React.lazy(() =>
  import('./views/Abuddy/QuickReply/QuickReplyCreate'),
);
const abuddyQuickReplyDetail = React.lazy(() =>
  import('./views/Abuddy/QuickReply/QuickReplyDetail'),
);
const abuddySubCategoryDetail = React.lazy(() =>
  import('./views/Abuddy/SubCategory/SubCategoryDetail'),
);
const abuddySmartReport = React.lazy(() =>
  import('./views/Abuddy/SmartReport/ReportsList'),
);
const abuddySmartReportCreate = React.lazy(() =>
  import('./views/Abuddy/SmartReport/SmartReportCreate'),
);
const abuddySmartReportEdit = React.lazy(() =>
  import('./views/Abuddy/SmartReport/SmartReportDetail'),
);
const adminContentManagement = React.lazy(() =>
  import('./views/Content/Admin/ContentManagement'),
);
const adminContentManagementCreate = React.lazy(() =>
  import('./views/Content/Admin/ContentManagementCreate'),
);
const adminContentManagementDetail = React.lazy(() =>
  import('./views/Content/Admin/ContentManagementDetail'),
);
const aboContentManagement = React.lazy(() =>
  import('./views/Content/ABO/ContentManagement'),
);
const aboContentManagementDetail = React.lazy(() =>
  import('./views/Content/ABO/ContentManagementDetail'),
);
const libraryMainCategory = React.lazy(() =>
  import('./views/Abuddy/Library/MainCategory/MainCategory'),
);
const libraryMainCategoryCreate = React.lazy(() =>
  import('./views/Abuddy/Library/MainCategory/MainCategoryCreate'),
);
const libraryMainCategoryOrder = React.lazy(() =>
  import('./views/Abuddy/Library/MainCategory/MainCategoryOrder'),
);
const libraryMainCategoryDetail = React.lazy(() =>
  import('./views/Abuddy/Library/MainCategory/MainCategoryDetail'),
);
const librarySubCategory = React.lazy(() =>
  import('./views/Abuddy/Library/SubCategory/LibrarySubCategory'),
);
const librarySubCategoryCreate = React.lazy(() =>
  import('./views/Abuddy/Library/SubCategory/LibrarySubCategoryCreate'),
);
const librarySubCategoryDetail = React.lazy(() =>
  import('./views/Abuddy/Library/SubCategory/LibrarySubCategoryDetail'),
);

const OffHour = React.lazy(() =>
  import('./views/Chatlive/OffHour/OffHour'),
);

const ListOption = React.lazy(() =>
  import('./views/Chatlive/ListOption/ListOption'),
);

const Schedule = React.lazy(() =>
  import('./views/Chatlive/Schedule/Schedule'),
);

const Survey = React.lazy(() =>
  import('./views/Chatlive/Survey/Survey'),
);

const SurveyAnswer = React.lazy(() =>
  import('./views/Chatlive/SurveyAnswer/SurveyAnswer'),
);

const Department = React.lazy(() =>
  import('./views/Chatlive/Department/Department'),
);
const ListAssesment = React.lazy(() =>
  import('./views/Assesment/ListAssesment/ListAssesment'),
);
const ListSuggestion = React.lazy(() =>
  import('./views/Assesment/ListSuggestion/ListSuggestion'),
);
const ListSolution = React.lazy(() =>
  import('./views/Assesment/ListSolution/ListSolution'),
);
const ListCondition = React.lazy(() =>
  import('./views/Assesment/TermsConditions/ListTermsConditions'),
);
const ListType = React.lazy(() =>
  import('./views/Assesment/ListType/ListType'),
);
const ListTypeDetail = React.lazy(() =>
  import('./views/Assesment/ListType/ListTypeDetail'),
);
const ListFoodCat = React.lazy(() =>
  import('./views/Assesment/ListFoodCat/ListFoodCat'),
);
const ListFoodCatEdit = React.lazy(() =>
  import('./views/Assesment/ListFoodCat/ListFoodCatEdit'),
);
const ListFoodMenu = React.lazy(() =>
  import('./views/Assesment/ListFoodMenu/ListFoodMenu'),
);
const ListFoodMenuEdit = React.lazy(() =>
  import('./views/Assesment/ListFoodMenu/ListFoodMenuEdit'),
);
const ListFoodMenuABO = React.lazy(() =>
  import('./views/Assesment/ListFoodMenuABO/ListFoodMenuABO'),
);
const ListFoodMenuABOView = React.lazy(() =>
  import('./views/Assesment/ListFoodMenuABO/ListFoodMenuABOView'),
);
const ListSupplement = React.lazy(() =>
  import('./views/Assesment/ListSupplement/ListSupplement'),
);
const ListSupplementEdit = React.lazy(() =>
  import('./views/Assesment/ListSupplement/ListSupplementEdit'),
);
const ListExerciseCategory = React.lazy(() =>
  import('./views/Assesment/ListExerciseCategory/ListExerciseCategory'),
);
const ListExerciseCategoryEdit = React.lazy(() =>
  import('./views/Assesment/ListExerciseCategory/ListExerciseCategoryEdit'),
);
const ListExerciseMenu = React.lazy(() =>
  import('./views/Assesment/ListExerciseMenu/ListExerciseMenu'),
);
const ListExerciseMenuEdit = React.lazy(() =>
  import('./views/Assesment/ListExerciseMenu/ListExerciseMenuEdit'),
);
const ListExerciseTemp = React.lazy(() =>
  import('./views/Assesment/ListExerciseTemp/ListExerciseTemp'),
);


const SuggestionCreate = React.lazy(() => import('./views/Assesment/ListSuggestion/SuggestionCreate'));
const SolutionCreate = React.lazy(() => import('./views/Assesment/ListSolution/SolutiontionCreate'));
const ConditionsCreate = React.lazy(() => import('./views/Assesment/TermsConditions/TermsConditionsCreate'));

const SolutionEdit = React.lazy(() => import('./views/Assesment/ListSolution/SolutionEdit'));
const ConditionsEdit = React.lazy(() => import('./views/Assesment/TermsConditions/TermsConditionsEdit'));
const AssesmentCreate = React.lazy(() => import('./views/Assesment/ListAssesment/AssesmentCreate'));

const HWAssessmentCreate = React.lazy(() => import('./views/Assesment/ListAssesment/HWAssessment/HWAssessmentCreate'));
const HWAssessmentEdit = React.lazy(() => import('./views/Assesment/ListAssesment/HWAssessment/HWAssessmentEdit'));
const ListTypeCreate = React.lazy(() => import('./views/Assesment/ListType/ListTypeCreate'));
const ListFoodCatCreate = React.lazy(() => import('./views/Assesment/ListFoodCat/ListFoodCatCreate'));
const ListFoodCatReorder = React.lazy(() => import('./views/Assesment/ListFoodCat/ListFoodCatReorder'));
const ListFoodMenuCreate = React.lazy(() => import('./views/Assesment/ListFoodMenu/ListFoodMenuCreate'));
const ListSupplementCreate = React.lazy(() => import('./views/Assesment/ListSupplement/ListSupplementCreate'));
const ListExerciseCategoryCreate = React.lazy(() => import('./views/Assesment/ListExerciseCategory/ListExerciseCategoryCreate'));
const ListExerciseCategoryReorder = React.lazy(() => import('./views/Assesment/ListExerciseCategory/ListExerciseCategoryReorder'));
const ListExerciseMenuCreate = React.lazy(() => import('./views/Assesment/ListExerciseMenu/ListExerciseMenuCreate'));
const ListExerciseMenuReorder = React.lazy(() => import('./views/Assesment/ListExerciseMenu/ListExerciseMenuReorder'));
const ListExerciseTempCreate = React.lazy(() => import('./views/Assesment/ListExerciseTemp/ListExerciseTempCreate'));
const ListExerciseTempReorder = React.lazy(() => import('./views/Assesment/ListExerciseTemp/ListExerciseTempReorder'));
const ListExerciseTempEdit = React.lazy(() => import('./views/Assesment/ListExerciseTemp/ListExerciseTempEdit'));
const ChallengeCreate = React.lazy(() => import('./views/Challenge/ChallengeCreate'));
const ChallengeEdit = React.lazy(() => import('./views/Challenge/ChallengeEdit'));
const Challenge = React.lazy(() => import('./views/Challenge/Challenge'));
const GMNDailyMessageList = React.lazy(() => import('./views/GMNDailyMessage/GMNDailyMessageList'));
const GMNDailyMessageForm = React.lazy(() => import('./views/GMNDailyMessage/GMNDailyMessageForm'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },

  { path: '/products', exact: true, name: 'Products', component: Products },
  { path: '/products/create', name: 'Create', component: ProductCreate },
  { path: '/products/:id', name: 'Edit', component: ProductDetail },

  { path: '/customers', exact: true, name: 'Customers', component: Customers },
  {
    path: '/customers/status/:id',
    exact: true,
    name: 'Block / Unblock',
    component: CustomerStatus,
  },
  {
    path: '/customers/detail/:id',
    exact: true,
    name: 'Detail',
    component: CustomersDetail,
  },
  {
    path: '/customers/:id/edit',
    exact: true,
    name: 'Edit',
    component: CustomersEdit,
  },

  { path: '/messages', exact: true, name: 'Messages', component: Messages },
  { path: '/messages/create', name: 'Send Message', component: MessageCreate },
  {
    path: '/messages/email',
    name: 'Email Notification',
    component: MessageEmail,
  },
  { path: '/messages/:id', name: 'Detail', component: MessagesDetail },

  {
    path: '/rich-menu-management',
    exact: true,
    name: 'Rich Menu Management',
    component: RichMenu,
  },
  {
    path: '/rich-menu-management/create',
    name: 'Create',
    component: RichMenuCreate,
  },
  {
    path: '/rich-menu-management/:id',
    name: 'Edit',
    component: RichMenuCreate,
  },

  { path: '/users', exact: true, name: 'Users', component: Users },
  { path: '/users/create', name: 'Create', component: UsersCreate },
  { path: '/users/:id/edit', name: 'Edit', component: UsersEdit },

  {
    path: '/user-activities',
    exact: true,
    name: 'User Activities',
    component: UserActivities,
  },
  {
    path: '/user-activities/:id',
    name: 'Detail',
    component: UserActivitiesDetail,
  },

  { path: '/profile', exact: true, name: 'Edit Profile', component: Profile },
  { path: '/500', name: 'Access Denied', component: Page500 },

  { path: '/tm-dashboard', exact: true, name: 'TM Dashboard', component: TmDashboard },
  { path: '/transaction-log', exact: true, name: 'Transaction log', component: TmLogsView },

  {
    path: '/purchaseHistory',
    exact: true,
    name: 'Purchase History',
    component: questions,
  },
  {
    path: '/purchaseHistory/form',
    exact: true,
    name: 'Form',
    component: questionCreate,
  },
  {
    path: '/purchaseHistory/listAnswer',
    exact: true,
    name: 'Edit List Answer',
    component: questionEditOrder,
  },

  {
    path: '/reports',
    exact: true,
    name: 'Register incomplete',
    component: reports,
  },

  {
    path: '/activityLog',
    exact: true,
    name: 'Activity Log Report',
    component: activityLog,
  },

  {
    path: '/abuddy/intro-oa',
    exact: true,
    name: 'A Buddy Intro OA',
    component: abuddyIntroOA,
  },
  {
    path: '/abuddy/intro-oa/order',
    exact: true,
    name: 'Order',
    component: abuddyIntroOaOrder,
  },
  {
    path: '/abuddy/intro-oa/create',
    exact: true,
    name: 'Create',
    component: abuddyIntroOACreate,
  },
  {
    path: '/abuddy/intro-oa/:id',
    exact: true,
    name: 'Edit',
    component: abuddyIntroOADetail,
  },

  {
    path: '/abuddy/intro-group',
    exact: true,
    name: 'A Buddy Intro Group',
    component: abuddyIntroGroup,
  },
  {
    path: '/abuddy/intro-group/order',
    exact: true,
    name: 'Order',
    component: abuddyIntroGroupOrder,
  },
  {
    path: '/abuddy/intro-group/create',
    exact: true,
    name: 'Create',
    component: abuddyIntroGroupCreate,
  },
  {
    path: '/abuddy/intro-group/:id',
    exact: true,
    name: 'Edit',
    component: abuddyIntroGroupDetail,
  },

  {
    path: '/abuddy/category',
    exact: true,
    name: 'A Buddy Category',
    component: abuddyCategory,
  },
  {
    path: '/abuddy/category/order',
    exact: true,
    name: 'Order',
    component: abuddyCategoryOrder,
  },
  {
    path: '/abuddy/category/create',
    exact: true,
    name: 'Create',
    component: abuddyCategoryCreate,
  },
  {
    path: '/abuddy/category/:id',
    exact: true,
    name: 'Edit',
    component: abuddyCategoryDetail,
  },
  {
    path: '/abuddy/sub-category',
    exact: true,
    name: 'A Buddy Sub Category',
    component: abuddySubCategory,
  },
  {
    path: '/abuddy/sub-category/create',
    exact: true,
    name: 'Create',
    component: abuddySubCategoryCreate,
  },
  {
    path: '/abuddy/sub-category/:id',
    exact: true,
    name: 'Edit',
    component: abuddySubCategoryDetail,
  },
  {
    path: '/abuddy/quick-reply',
    exact: true,
    name: 'A Buddy Quick Reply',
    component: abuddyQuickReply,
  },
  {
    path: '/abuddy/quick-reply/create',
    exact: true,
    name: 'Create',
    component: abuddyQuickReplyCreate,
  },
  {
    path: '/abuddy/quick-reply/:id',
    exact: true,
    name: 'Edit',
    component: abuddyQuickReplyDetail,
  },
  {
    path: '/abuddy/smart-report',
    exact: true,
    name: 'Smart Report',
    component: abuddySmartReport,
  },
  {
    path: '/abuddy/smart-report/create',
    exact: true,
    name: 'Create',
    component: abuddySmartReportCreate,
  },
  {
    path: '/abuddy/smart-report/:id',
    exact: true,
    name: 'Edit',
    component: abuddySmartReportEdit,
  },
  {
    path: '/content-management/admin-management',
    exact: true,
    name: 'Content Management',
    component: adminContentManagement,
  },
  {
    path: '/content-management/admin-management/create',
    exact: true,
    name: 'Create',
    component: adminContentManagementCreate,
  },
  {
    path: '/content-management/admin-management/:id',
    name: 'Edit',
    component: adminContentManagementDetail,
  },
  {
    path: '/content-management/abo-management',
    exact: true,
    name: 'Content Management',
    component: aboContentManagement,
  },
  {
    path: '/content-management/abo-management/:id',
    name: 'Edit',
    component: aboContentManagementDetail,
  },

  {
    path: '/library/main-category',
    exact: true,
    name: 'A Buddy Library Main Category',
    component: libraryMainCategory,
  },
  {
    path: '/library/main-category/create',
    exact: true,
    name: 'Create',
    component: libraryMainCategoryCreate,
  },
  {
    path: '/library/main-category/order',
    exact: true,
    name: 'Order',
    component: libraryMainCategoryOrder,
  },
  {
    path: '/library/main-category/:id',
    exact: true,
    name: 'Order',
    component: libraryMainCategoryDetail,
  },

  {
    path: '/library/sub-category',
    exact: true,
    name: 'A Buddy Library Sub Category',
    component: librarySubCategory,
  },
  {
    path: '/library/sub-category/create',
    exact: true,
    name: 'Create',
    component: LibrarySubCategoryCreate,
  },
  {
    path: '/library/sub-category/:id',
    exact: true,
    name: 'Order',
    component: librarySubCategoryDetail,
  },
  {
    path: '/chatlive/off-hour',
    exact: true,
    name: 'Off Hours',
    component: OffHour,
  },
  {
    path: '/chatlive/list-option',
    exact: true,
    name: 'List Options',
    component: ListOption,
  },
  {
    path: '/chatlive/schedule',
    exact: true,
    name: 'Schedules',
    component: Schedule,
  },
  {
    path: '/chatlive/survey',
    exact: true,
    name: 'Survey',
    component: Survey,
  },
  {
    path: '/chatlive/survey-answer',
    exact: true,
    name: 'Survey-Answer',
    component: SurveyAnswer,
  },
  {
    path: '/chatlive/department',
    exact: true,
    name: 'Department',
    component: Department,
  },
  {
    path: '/assesment/list-assesment',
    exact: true,
    name: 'ListAssesment',
    component: ListAssesment,
  },
  { path: '/assesment/create-assesment', name: 'Create', component: AssesmentCreate },
  { path: '/assesment/:id/edit', name: 'Edit', component: AssesmentEdit },
  {
    path: '/assesment/list-assesment/create-hw-assessment',
    exact: true,
    name: 'Create',
    component: HWAssessmentCreate
  },
  { path: '/assesment/list-assesment/:id/hw-edit', exact: true, name: 'Edit', component: HWAssessmentEdit },
  {
    path: '/assesment/list-suggestion',
    exact: true,
    name: 'ListSuggestion',
    component: ListSuggestion,
  },

  { path: '/assesment/create-suggestion', name: 'Create', component: SuggestionCreate },

  { path: '/assesment/:id/edit-suggestion', name: 'Edit', component: SuggestionEdit },

  {
    path: '/assesment/list-solution',
    exact: true,
    name: 'ListSolution',
    component: ListSolution,
  },
  { path: '/assesment/create-solution', name: 'Create', component: SolutionCreate },
  { path: '/assesment/:id/edit-solution', name: 'Edit', component: SolutionEdit },
  {
    path: '/assesment/list-conditions',
    exact: true,
    name: 'Conditions',
    component: ListCondition,
  },
  {
    path: '/challenge',
    exact: true,
    name: 'Challenge',
    component: Challenge,
  },
  { path: '/assesment/create-conditions', name: 'Create', component: ConditionsCreate },
  { path: '/assesment/:id/edit-conditions', name: 'Edit', component: ConditionsEdit },
  { path: '/assesment/list-type', exact: true, name: 'List Type', component: ListType },
  { path: '/assesment/list-type/create', exact: true, name: 'Create', component: ListTypeCreate },
  { path: '/assesment/list-type/:id', exact: true, name: 'Edit', component: ListTypeDetail },
  { path: '/assesment/list-food-cat', exact: true, name: 'ListFoodCat', component: ListFoodCat },
  { path: '/assesment/list-food-cat/create', exact: true, name: 'Create', component: ListFoodCatCreate },
  { path: '/assesment/list-food-cat/order', exact: true, name: 'Order', component: ListFoodCatReorder },
  { path: '/assesment/list-food-cat/:id', exact: true, name: 'Edit', component: ListFoodCatEdit },
  { path: '/assesment/list-food-menu', exact: true, name: 'ListFoodMenu', component: ListFoodMenu },
  { path: '/assesment/list-food-menu/create', exact: true, name: 'Create', component: ListFoodMenuCreate },
  { path: '/assesment/list-food-menu/:id', exact: true, name: 'Edit', component: ListFoodMenuEdit },
  { path: '/assesment/list-food-menu-ABO', exact: true, name: 'ListFoodMenuABO', component: ListFoodMenuABO },
  { path: '/assesment/list-food-menu-ABO/:id', exact: true, name: 'ListFoodMenuABOView', component: ListFoodMenuABOView },
  { path: '/assesment/list-supplement', exact: true, name: 'ListSupplement', component: ListSupplement },
  { path: '/assesment/list-supplement/create', exact: true, name: 'Create', component: ListSupplementCreate },
  { path: '/assesment/list-supplement/:id', exact: true, name: 'Edit', component: ListSupplementEdit },
  { path: '/assesment/list-exercise-category', exact: true, name: 'ListExerciseCat', component: ListExerciseCategory },
  { path: '/assesment/list-exercise-category/order', exact: true, name: 'Order', component: ListExerciseCategoryReorder },
  { path: '/assesment/list-exercise-category/create', exact: true, name: 'Create', component: ListExerciseCategoryCreate },
  { path: '/assesment/list-exercise-category/:id', exact: true, name: 'Edit', component: ListExerciseCategoryEdit },
  { path: '/assesment/list-exercise-menu', exact: true, name: 'ListExerciseMenu', component: ListExerciseMenu },
  { path: '/assesment/list-exercise-menu/order', exact: true, name: 'Order', component: ListExerciseMenuReorder },
  { path: '/assesment/list-exercise-menu/create', exact: true, name: 'Create', component: ListExerciseMenuCreate },
  { path: '/assesment/list-exercise-menu/:id', exact: true, name: 'Edit', component: ListExerciseMenuEdit },
  { path: '/assesment/list-exercise-temp', exact: true, name: 'ListExerciseTemp', component: ListExerciseTemp },
  { path: '/assesment/list-exercise-temp/order', exact: true, name: 'Order', component: ListExerciseTempReorder },
  { path: '/assesment/list-exercise-temp/create', exact: true, name: 'Create', component: ListExerciseTempCreate },
  { path: '/assesment/list-exercise-temp/:id', exact: true, name: 'Edit', component: ListExerciseTempEdit },
  { path: '/challenge/create', exact: true, name: 'Create', component: ChallengeCreate },
  { path: '/challenge/:id', exact: true, name: 'Edit', component: ChallengeEdit },
  { path: '/gmn-daily-message', exact: true, name: 'GMN message', component: GMNDailyMessageList },
  { path: '/gmn-daily-message/create', exact: true, name: 'Create message', component: GMNDailyMessageForm },
  { path: '/gmn-daily-message/:id', exact: true, name: 'Edit message', component: GMNDailyMessageForm },
  
];

export default routes;
